(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tracely-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var PH = /\[[^\]]+\]/;

  function markPlaceholders(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      var p = n.parentNode;
      if (PH.test(n.nodeValue) && p && !p.closest('script, style, mark, .tr-ph')) nodes.push(n);
    }
    nodes.forEach(function (node) {
      var frag = document.createDocumentFragment();
      node.nodeValue.split(/(\[[^\]]+\])/g).forEach(function (part) {
        if (!part) return;
        if (PH.test(part)) {
          var m = document.createElement('mark');
          m.className = 'tr-ph';
          m.textContent = part;
          frag.appendChild(m);
        } else {
          frag.appendChild(document.createTextNode(part));
        }
      });
      node.parentNode.replaceChild(frag, node);
    });
  }

  function initTracely(root) {
    if (!root || root.getAttribute('data-tr-ready')) return;
    root.setAttribute('data-tr-ready', '1');

    /* Photo counter for the swipeable gallery */
    var gallery = root.querySelector('[data-tr-gallery]');
    var count = root.querySelector('[data-tr-count]');
    if (gallery && count) {
      var total = gallery.children.length;
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
        count.textContent = (i + 1) + ' / ' + total;
      }, { passive: true });
    }

    /* Show the chosen variant's price */
    var select = root.querySelector('[data-tr-variant]');
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var price = opt.getAttribute('data-price');
        root.querySelectorAll('[data-tr-price]').forEach(function (el) { el.textContent = price; });
      });
    }

    /* Sticky Add to cart shows whenever the main button is off screen */
    var sticky = root.querySelector('[data-tr-sticky]');
    var mainButton = root.querySelector('[data-tr-add]');
    if (sticky && mainButton) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-on', !entries[0].isIntersecting);
        }).observe(mainButton);
      } else {
        sticky.classList.add('is-on');
      }
    }

    /* In the theme editor only: outline [placeholder text] so it is easy to find */
    if (window.Shopify && window.Shopify.designMode) markPlaceholders(root);
  }

  function boot() {
    document.querySelectorAll('[data-tracely]').forEach(initTracely);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-tracely]') : null;
    if (root) initTracely(root);
  });

  window.initTracely = initTracely;
})();

  } catch(e) { console.error(e); }
})();
})();
